import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { usePadStore } from '@stores/pad'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const padStore = usePadStore()

  padStore.hydrateFromStorage(Discipline.ELA)
  void padStore.ensureEla(to)
})
